import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { Info } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

const TOOLTIP_MAX_WIDTH = 280;

const CatalogMinimumStockInfo = () => {
  const { translate } = useTranslation();

  return (
    <Tooltip
      placement="bottom-left"
      TooltipContent={
        <Stack sx={{ gap: 1, maxWidth: TOOLTIP_MAX_WIDTH }}>
          <Typography variant="body2" color="inherit">
            {translate(LangEnum.CATALOG_MINIMUM_STOCK_RULE_DESCRIPTION)}
          </Typography>
          <Typography variant="body2" color="inherit">
            {translate(LangEnum.CATALOG_MINIMUM_STOCK_RULE_TOOLTIP)}
          </Typography>
        </Stack>
      }
    >
      <Box sx={{ display: 'flex', color: 'text.secondary' }}>
        <Icon icon={Info} size="sm" />
      </Box>
    </Tooltip>
  );
};

export default CatalogMinimumStockInfo;
